import React from 'react';
import ContentTemplate from 'web-library/stories/template/ContentTemplate/ContentTemplate';
import TitleHeader from 'web-library/stories/molecule/TitleHeader/TitleHeader';
import ForgotPasswordForm from '../../modules/profile/components/ForgotPasswordForm';

const ForgotPassword = () => (
  <>
    <TitleHeader title="Forgot Password" />

    <ContentTemplate>
      <ForgotPasswordForm />
    </ContentTemplate>
  </>
);

export default ForgotPassword;
